import React from 'react'
import { BreadcrumbLink } from 'legacy/components/Breadcrumbs'
import { withCatalogContext } from 'legacy/common/context'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import { type Department, type Aisle } from 'legacy/routes/catalog/types'

interface AisleBreadcrumbLinkProps extends RetailerRouteComponentProps {
  aisle: Aisle
  department: Department
}

const AisleBreadcrumbLink = ({ url, department, aisle }: AisleBreadcrumbLinkProps) => {
  if (!department || !aisle) return null

  const aisleLink = {
    pathname: url('aisle', {
      department_id: String(department.id),
      aisle_id: String(aisle.id),
    }),
    query: {
      page: 1,
    },
  }

  return <BreadcrumbLink to={aisleLink}>{aisle.name}</BreadcrumbLink>
}

export default withCatalogContext(AisleBreadcrumbLink)
